module.exports = __webpack_public_path__ + "img/DESIGNELEMENTS.5dee12d7.svg";